var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideMenu),expression:"hideMenu"}],staticClass:"menu-dropdown d-flex cursor-pointer",class:[
      _vm.addClassStatus,
      { 'with-arrow': _vm.selected.value === 'pending' || _vm.selected.value === 'in_progress' }
    ]},[_c('div',{staticClass:"mx-2"},[_c('img',{attrs:{"src":_vm.selected.icon,"width":"13px"}})]),_vm._v(" "+_vm._s(_vm.selected.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }